import { useTranslation } from 'react-i18next';
import { Card } from '../../shared/Card/Card';
import { Shimmer } from '../../shared/Shimmer/Shimmer';
import styles from './MetricStripSkeleton.module.css';

/** Loading state for {@link MetricStrip} — four tiles matching MetricCard's layout. */
export function MetricStripSkeleton() {
  const { t } = useTranslation();

  return (
    <section className={styles.strip} aria-busy="true" aria-label={t('productivity.skeleton.loading')}>
      {Array.from({ length: 4 }, (_, i) => (
        <Card as="article" key={i}>
          <div className={styles.top}>
            <Shimmer className={styles.iconBox} wave={i * 0.06} />
            <Shimmer className={styles.trend} wave={i * 0.06} />
          </div>
          <Shimmer className={styles.value} wave={i * 0.06} />
          <Shimmer className={styles.label} wave={i * 0.06} />
          <Shimmer className={styles.sublabel} wave={i * 0.06} />
        </Card>
      ))}
    </section>
  );
}